import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Routes, Route, Switch, Redirect } from "react-router-dom";
import HomeRoute from "../Modules/Home/Routes/HomeRoute";
import PaymentRoute from "../Modules/Payment/Routes/PaymentRoute";
import LoginRoute from "../../GlobalModules/Login/Routes/LoginRoute";
import BookingRoute from "../Modules/Booking/Routes/BookingRoute";
import { connect } from 'react-redux';
import { setToken } from '../../GlobalModules/Login/Actions/LoginAction';
import { withNamespaces } from 'react-i18next';
import ProfileRoute from "../../GlobalModules/UserProfile/Routes/ProfileRoute";
import FooterListRoute from "../../GlobalModules/FooterList/Routes/FooterListRoute";
import ThemeDemo from "../../Utility/Components/ThemeDemo";
import PaymentSuccess from '../Modules/Home/Components/PaymentSuccess';
import PaymentFailed from '../Modules/Home/Components/PaymentFailed';
import PaymentTimeout from '../Modules/Home/Components/PaymentTimeout';
import PaymentAborted from '../Modules/Home/Components/PaymentAborted';
import PaymentInvalid from '../Modules/Home/Components/PaymentInvalid';
import OnlinePaymentStatus from '../Modules/Payment/Pages/OnlinePaymentStatus';
import RazorPayPaymentSuccessful from '../Modules/Home/Components/RazorPayPaymentSuccessful';

class index extends Component {
  render() {
    const { isLoggedIn, userCredentials } = this.props;
    return (
      <Switch>
        <Route exact path="/" component={HomeRoute} />
        <Route exact path="/theme-demo" component={ThemeDemo} />
        <Route exact path="/:lng/theme-demo" component={ThemeDemo} />
        <Route
          path="/:lng/home"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/tour-list"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/folio-history"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/tour-details/:slug"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          exact
          path="/:lng/online-payment-status"
          render={(routeProps) => (
            <OnlinePaymentStatus {...routeProps} />
          )}
        />
        <Route
          exact
          path="/:lng/payment-status"
          render={(routeProps) => (
            <RazorPayPaymentSuccessful {...routeProps} />
          )}
        />
        {/* <Route
          exact
          path="/:lng/payment-success"
          render={(routeProps) => (
            <PaymentSuccess {...routeProps} />
          )}
        />
        <Route
          exact
          path="/:lng/payment-failed"
          render={(routeProps) => (
            <PaymentFailed {...routeProps} />
          )}
        /> */}
        {/* <Route
          exact
          path="/:lng/payment-timeout"
          render={(routeProps) => (
            <PaymentTimeout {...routeProps} />
          )}
        />
        <Route
          exact
          path="/:lng/payment-aborted"
          render={(routeProps) => (
            <PaymentAborted {...routeProps} />
          )}
        />
        <Route
          exact
          path="/:lng/payment-invalid"
          render={(routeProps) => (
            <PaymentInvalid {...routeProps} />
          )}
        /> */}
        <Route
          path="/:lng/property-type-list"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/search"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route exact path="/:lng/notfound" component={HomeRoute} />
        <Route exact path="/:lng/login/:type?" component={LoginRoute} />
        <Route exact path="/:lng/forgot-password/:type?" component={LoginRoute} />
        <Route exact path="/:lng/register/:type?" component={LoginRoute} />
        <Route exact path="/:lng/comingsoon" component={HomeRoute} />
        <Route
          path="/:lng/manage-account"
          render={(routeProps) => (
            isLoggedIn ? <ProfileRoute {...routeProps} isLoggedIn={isLoggedIn} /> : <Redirect to={`/${localStorage.getItem('i18nextLng')}/login`} />
          )}
        />
        <Route
          path="/:lng/change-password"
          render={(routeProps) => (
            isLoggedIn ? <ProfileRoute {...routeProps} isLoggedIn={isLoggedIn} /> : <Redirect to={`/${localStorage.getItem('i18nextLng')}/login`} />
          )}
        />

        <Route
          path="/:lng/booking-history/:customer_type?"
          render={(routeProps) => (
            isLoggedIn ? <BookingRoute {...routeProps} isLoggedIn={isLoggedIn} /> : <Redirect to={`/${localStorage.getItem('i18nextLng')}/login`} />
          )}
        />
        <Route
          path="/:lng/booking-details"
          render={(routeProps) => (
            isLoggedIn ? <BookingRoute {...routeProps} isLoggedIn={isLoggedIn} /> : <Redirect to={`/${localStorage.getItem('i18nextLng')}/login`} />
          )}
        />
        <Route
          path="/:lng/property-details/:slug"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/tour-details/:slug"
          render={(routeProps) => (
            <HomeRoute {...routeProps} isLoggedIn={isLoggedIn} />
          )}
        />
        <Route
          path="/:lng/about-us"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/terms-conditions"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/faq"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/privacy-policy"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/sitemap"
          render={(routeProps) => (
            <FooterListRoute {...routeProps} />
          )}
        />
        <Route
          path="/:lng/credit-note"
          render={(routeProps) => (
            isLoggedIn ?
            <BookingRoute {...routeProps} isLoggedIn={isLoggedIn} />
            :
            <Redirect to={`/${localStorage.getItem('i18nextLng')}/login`} />
          )}
        />
        <Route
          path="*"
          render={() => {
            const lng = localStorage.getItem('i18nextLng') || 'en';
            return <Redirect to={`/${lng}/notfound`} />;
          }}
        />
        <Route
          path="*"
          render={() => {
            const lng = localStorage.getItem('i18nextLng') || 'en';
            return <Redirect to={`/${lng}/comingsoon`} />;
          }}
        />

      </Switch>
    );
  }
}

const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    isLoggedIn: globalState.LoginReducer.token !== '',

  };
}

export default connect(mapStateToProps, { setToken })(withNamespaces()(index));